import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { TRIP_STATUSES } from 'src/common/tripStatuses';
import { isDispatchTrip } from 'src/features/dispatch/common/isDispatchTrip';

import { TripDetailsEstimatedCompletion } from './TripDetailsEstimatedCompletion';
import { TripDetailsEstimatedPickup } from './TripDetailsEstimatedPickup';

interface TripEstimatedTimesProps {
  isTripDataLoading: boolean;
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead;
}

export function TripEstimatedTimes({
  isTripDataLoading,
  trip,
}: TripEstimatedTimesProps) {
  const showEstimatedPickupTime = trip.status === TRIP_STATUSES.EN_ROUTE;

  const tripStatusesToShowEstimatedCompletionTime = [
    TRIP_STATUSES.EN_ROUTE,
    TRIP_STATUSES.AT_PICKUP,
    TRIP_STATUSES.TRANSPORTING,
    TRIP_STATUSES.AT_DROPOFF,
  ];
  const showEstimatedCompletionTime =
    tripStatusesToShowEstimatedCompletionTime.includes(trip.status);

  const isDispatchableTrip = isDispatchTrip(trip);

  const willRenderEstimatedPickup =
    showEstimatedPickupTime &&
    isDispatchableTrip &&
    (isTripDataLoading || !!trip.timing?.estimated_pickup_arrival_time);

  const willRenderEstimatedCompletion =
    showEstimatedCompletionTime &&
    isDispatchableTrip &&
    (isTripDataLoading || !!trip.timing?.estimated_completion_time);

  const tripHasEstimatedPickupAndCompletionTime =
    isDispatchableTrip &&
    !!trip.timing?.estimated_pickup_arrival_time &&
    !!trip.timing.estimated_completion_time;

  const showDivider =
    willRenderEstimatedPickup &&
    willRenderEstimatedCompletion &&
    tripHasEstimatedPickupAndCompletionTime;

  if (!willRenderEstimatedPickup && !willRenderEstimatedCompletion) {
    return null;
  }

  return (
    <div
      className={
        showDivider
          ? 'flex justify-evenly gap-2 py-2'
          : 'flex justify-start gap-2 py-2'
      }
    >
      {willRenderEstimatedPickup && (
        <TripDetailsEstimatedPickup
          isTripDataLoading={isTripDataLoading}
          trip={trip}
        />
      )}
      {showDivider && (
        <div
          data-testid="estimated-times-divider"
          role="separator"
          className="w-px bg-gray-200"
        />
      )}
      {willRenderEstimatedCompletion && (
        <TripDetailsEstimatedCompletion
          isTripDataLoading={isTripDataLoading}
          trip={trip}
        />
      )}
    </div>
  );
}
